import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import O from "mux-embed";
import ue from "hls.js";
var f = ue;

var x = /*#__PURE__*/function (_Error) {
  _inherits(x, _Error);

  var _super = _createSuper(x);

  function x(n) {
    var _this;

    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x.MEDIA_ERR_CUSTOM;
    var o = arguments.length > 2 ? arguments[2] : undefined;
    var a = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, x);

    var s;
    _this = _super.call(this, n);
    _this.name = "MediaError", _this.code = r, _this.context = a, _this.fatal = o != null ? o : r >= x.MEDIA_ERR_NETWORK && r <= x.MEDIA_ERR_ENCRYPTED, _this.message || (_this.message = (s = x.defaultMessages[_this.code]) != null ? s : "");
    return _this;
  }

  return x;
}( /*#__PURE__*/_wrapNativeSuper(Error)),
    g = x;

g.MEDIA_ERR_ABORTED = 1, g.MEDIA_ERR_NETWORK = 2, g.MEDIA_ERR_DECODE = 3, g.MEDIA_ERR_SRC_NOT_SUPPORTED = 4, g.MEDIA_ERR_ENCRYPTED = 5, g.MEDIA_ERR_CUSTOM = 100, g.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail.",
  3: "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.",
  4: "An unsupported error occurred. The server or network failed, or your browser does not support this format.",
  5: "The media is encrypted and there are no keys to decrypt it."
};

var de = function de(e) {
  return e == null;
},
    C = function C(e, t) {
  return de(t) ? !1 : e in t;
},
    E = {
  ANY: "any",
  MUTED: "muted"
},
    v = {
  ON_DEMAND: "on-demand",
  LIVE: "live",
  UNKNOWN: "unknown"
},
    R = {
  MSE: "mse",
  NATIVE: "native"
},
    A = {
  HEADER: "header",
  QUERY: "query",
  NONE: "none"
},
    We = Object.values(A),
    b = {
  M3U8: "application/vnd.apple.mpegurl",
  MP4: "video/mp4"
},
    h = {
  HLS: b.M3U8
},
    Be = Object.keys(h),
    Ke = [].concat(_toConsumableArray(Object.values(b)), ["hls", "HLS"]),
    qe = {
  upTo720p: "720p",
  upTo1080p: "1080p",
  upTo1440p: "1440p",
  upTo2160p: "2160p"
},
    Ye = {
  noLessThan480p: "480p",
  noLessThan540p: "540p",
  noLessThan720p: "720p",
  noLessThan1080p: "1080p",
  noLessThan1440p: "1440p",
  noLessThan2160p: "2160p"
},
    $e = {
  DESCENDING: "desc"
};

var M = function M(e, t, n, r) {
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : e;
  o.addEventListener(t, n, r), e.addEventListener("teardown", function () {
    o.removeEventListener(t, n);
  }, {
    once: !0
  });
};

function U(e, t, n) {
  t && n > t && (n = t);

  for (var r = 0; r < e.length; r++) {
    if (e.start(r) <= n && e.end(r) >= n) return !0;
  }

  return !1;
}

var F = function F(e) {
  var t = e.indexOf("?");
  if (t < 0) return [e];
  var n = e.slice(0, t),
      r = e.slice(t);
  return [n, r];
},
    L = function L(e) {
  var t = e.type;

  if (t) {
    var r = t.toUpperCase();
    return C(r, h) ? h[r] : t;
  }

  var n = e.src;
  return n ? pe(n) : "";
},
    I = function I(e) {
  return e === "VOD" ? v.ON_DEMAND : v.LIVE;
},
    D = function D(e) {
  return e === "EVENT" ? Number.POSITIVE_INFINITY : e === "VOD" ? Number.NaN : 0;
},
    pe = function pe(e) {
  var t = "";

  try {
    t = new URL(e).pathname;
  } catch (_unused) {
    console.error("invalid url");
  }

  var n = t.lastIndexOf(".");
  if (n < 0) return "";
  var o = t.slice(n + 1).toUpperCase();
  return C(o, b) ? b[o] : "";
};

var le = Object.values(E),
    W = function W(e) {
  return typeof e == "boolean" || typeof e == "string" && le.includes(e);
},
    B = function B(_ref, t, n) {
  var e = _ref.autoplay;

  var r = !1,
      o = !1,
      a = W(e) ? e : !!e,
      s = function s() {
    r || M(t, "playing", function () {
      r = !0;
    }, {
      once: !0
    });
  };

  if (s(), M(t, "loadstart", function () {
    r = !1, s(), w(t, a);
  }, {
    once: !0
  }), M(t, "loadstart", function () {
    n || (o = !Number.isFinite(t.duration)), w(t, a);
  }, {
    once: !0
  }), n && n.once(f.Events.LEVEL_LOADED, function (d, c) {
    var p;
    o = (p = c.details.live) != null ? p : !1;
  }), !a) {
    var d = function d() {
      !o || (n != null && n.liveSyncPosition ? t.currentTime = n.liveSyncPosition : Number.isFinite(t.seekable.end(0)) && (t.currentTime = t.seekable.end(0)));
    };

    n && M(t, "play", function () {
      t.preload === "metadata" ? n.once(f.Events.LEVEL_UPDATED, d) : d();
    }, {
      once: !0
    });
  }

  return function (d) {
    r || (a = W(d) ? d : !!d, w(t, a));
  };
},
    w = function w(e, t) {
  if (!t) return;

  var n = e.muted,
      r = function r() {
    return e.muted = n;
  };

  switch (t) {
    case E.ANY:
      e.play().catch(function () {
        e.muted = !0, e.play().catch(r);
      });
      break;

    case E.MUTED:
      e.muted = !0, e.play().catch(r);
      break;

    default:
      e.play().catch(function () {});
      break;
  }
};

var K = function K(_ref2, n, r) {
  var e = _ref2.preload,
      t = _ref2.src;

  var o = function o(u) {
    u != null && ["", "none", "metadata", "auto"].includes(u) ? n.setAttribute("preload", u) : n.removeAttribute("preload");
  };

  if (!r) return o(e), o;

  var a = !1,
      s = !1,
      i = r.config.maxBufferLength,
      d = r.config.maxBufferSize,
      c = function c(u) {
    o(u);
    var l = u != null ? u : n.preload;
    s || l === "none" || (l === "metadata" ? (r.config.maxBufferLength = 1, r.config.maxBufferSize = 1) : (r.config.maxBufferLength = i, r.config.maxBufferSize = d), p());
  },
      p = function p() {
    !a && t && (a = !0, r.loadSource(t));
  };

  return M(n, "play", function () {
    s = !0, r.config.maxBufferLength = i, r.config.maxBufferSize = d, p();
  }, {
    once: !0
  }), c(e), c;
};

function q(e, t) {
  var d;
  if (!("videoTracks" in e)) return;
  var n = new WeakMap();
  t.on(f.Events.MANIFEST_PARSED, function (c, p) {
    i();
    var u = e.addVideoTrack("main");
    u.selected = !0;

    var _iterator = _createForOfIteratorHelper(p.levels.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            l = _step$value[0],
            T = _step$value[1];

        var y = u.addRendition(T.url[0], T.width, T.height, T.videoCodec, T.bitrate);
        n.set(T, "".concat(l)), y.id = "".concat(l);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }), t.on(f.Events.AUDIO_TRACKS_UPDATED, function (c, p) {
    s();

    var _iterator2 = _createForOfIteratorHelper(p.audioTracks),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var u = _step2.value;
        var l = u.default ? "main" : "alternative",
            T = e.addAudioTrack(l, u.name, u.lang);
        T.id = "".concat(u.id), u.default && (T.enabled = !0);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }), e.audioTracks.addEventListener("change", function () {
    var u;
    var c = +((u = _toConsumableArray(e.audioTracks).find(function (l) {
      return l.enabled;
    })) == null ? void 0 : u.id),
        p = t.audioTracks.map(function (l) {
      return l.id;
    });
    c != t.audioTrack && p.includes(c) && (t.audioTrack = c);
  }), t.on(f.Events.LEVELS_UPDATED, function (c, p) {
    var T;
    var u = e.videoTracks[(T = e.videoTracks.selectedIndex) != null ? T : 0];
    if (!u) return;
    var l = p.levels.map(function (y) {
      return n.get(y);
    });

    var _iterator3 = _createForOfIteratorHelper(e.videoRenditions),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var y = _step3.value;
        y.id && !l.includes(y.id) && u.removeRendition(y);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });

  var r = function r(c) {
    var p = c.target.selectedIndex;
    p != t.nextLevel && o(p);
  },
      o = function o(c) {
    var p = e.currentTime,
        u = !1,
        l = function l(T, y) {
      u || (u = !Number.isFinite(y.endOffset));
    };

    t.on(f.Events.BUFFER_FLUSHING, l), t.nextLevel = c, t.off(f.Events.BUFFER_FLUSHING, l), u || t.trigger(f.Events.BUFFER_FLUSHING, {
      startOffset: p + 10,
      endOffset: 1 / 0,
      type: "video"
    });
  };

  (d = e.videoRenditions) == null || d.addEventListener("change", r);

  var a = function a() {
    var _iterator4 = _createForOfIteratorHelper(e.videoTracks),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var c = _step4.value;
        e.removeVideoTrack(c);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  },
      s = function s() {
    var _iterator5 = _createForOfIteratorHelper(e.audioTracks),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var c = _step5.value;
        e.removeAudioTrack(c);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  },
      i = function i() {
    a(), s();
  };

  t.once(f.Events.DESTROYING, i);
}

function Y(e, t) {
  t.on(f.Events.NON_NATIVE_TEXT_TRACKS_FOUND, function (o, _ref3) {
    var a = _ref3.tracks;
    a.forEach(function (s) {
      var c;
      var i = (c = s.subtitleTrack) != null ? c : s.closedCaptions,
          d = t.subtitleTracks.findIndex(function (_ref4) {
        var p = _ref4.lang,
            u = _ref4.name,
            l = _ref4.type;
        return p == (i == null ? void 0 : i.lang) && u === s.label && l.toLowerCase() === s.kind;
      });
      H(e, s.kind, s.label, i == null ? void 0 : i.lang, "".concat(s.kind).concat(d));
    });
  });

  var n = function n() {
    var s;
    if (!t.subtitleTracks.length) return;
    var o = Array.from(e.textTracks).find(function (i) {
      return i.id && i.mode === "showing" && ["subtitles", "captions"].includes(i.kind);
    }),
        a = "".concat((s = t.subtitleTracks[t.subtitleTrack]) == null ? void 0 : s.type.toLowerCase()).concat(t.subtitleTrack);

    if (o && (t.subtitleTrack < 0 || (o == null ? void 0 : o.id) !== a)) {
      var i = t.subtitleTracks.findIndex(function (_ref5) {
        var d = _ref5.lang,
            c = _ref5.name,
            p = _ref5.type;
        return d == o.language && c === o.label && p.toLowerCase() === o.kind;
      });
      t.subtitleTrack = i;
    }

    o && (o == null ? void 0 : o.id) === a && o.cues && Array.from(o.cues).forEach(function (i) {
      o.addCue(i);
    });
  };

  e.textTracks.addEventListener("change", n), t.on(f.Events.CUES_PARSED, function (o, _ref6) {
    var a = _ref6.track,
        s = _ref6.cues;
    var i = e.textTracks.getTrackById(a);
    if (!i) return;
    var d = i.mode === "disabled";
    d && (i.mode = "hidden"), s.forEach(function (c) {
      var p;
      (p = i.cues) != null && p.getCueById(c.id) || i.addCue(c);
    }), d && (i.mode = "disabled");
  }), t.once(f.Events.DESTROYING, function () {
    e.textTracks.removeEventListener("change", n), e.querySelectorAll("track[data-removeondestroy]").forEach(function (a) {
      a.remove();
    });
  });

  var r = function r() {
    Array.from(e.textTracks).forEach(function (o) {
      var a, s;

      if (!["subtitles", "caption"].includes(o.kind) && o.label === "thumbnails") {
        if (!((a = o.cues) != null && a.length)) {
          var i = e.querySelector('track[label="thumbnails"]'),
              d = (s = i == null ? void 0 : i.getAttribute("src")) != null ? s : "";
          i == null || i.removeAttribute("src"), setTimeout(function () {
            i == null || i.setAttribute("src", d);
          }, 0);
        }

        o.mode !== "hidden" && (o.mode = "hidden");
      }
    });
  };

  t.once(f.Events.MANIFEST_LOADED, r), t.once(f.Events.MEDIA_ATTACHED, r);
}

function H(e, t, n, r, o) {
  var a = document.createElement("track");
  return a.kind = t, a.label = n, r && (a.srclang = r), o && (a.id = o), a.track.mode = ["subtitles", "captions"].includes(t) ? "disabled" : "hidden", a.setAttribute("data-removeondestroy", ""), e.append(a), a.track;
}

function fe(e, t) {
  var n = Array.prototype.find.call(e.querySelectorAll("track"), function (r) {
    return r.track === t;
  });
  n == null || n.remove();
}

var P = "cuepoints",
    _ = Object.freeze({
  label: P
}),
    S = function S(e) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _,
      _ref7$label = _ref7.label,
      t = _ref7$label === void 0 ? P : _ref7$label;

  var n;
  return (n = Array.from(e.querySelectorAll("track")).find(function (r) {
    return r.track.label === t && r.track.kind === "metadata";
  })) == null ? void 0 : n.track;
};

function $(_x, _x2) {
  return _$.apply(this, arguments);
}

function _$() {
  _$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
    var n,
        r,
        _n$label,
        o,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            n = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _;
            r = S(e, n);

            if (r) {
              _context4.next = 8;
              break;
            }

            _n$label = n.label, o = _n$label === void 0 ? P : _n$label;
            r = H(e, "metadata", o);
            r.mode = "hidden";
            _context4.next = 8;
            return new Promise(function (a) {
              return setTimeout(function () {
                return a(void 0);
              }, 0);
            });

          case 8:
            return _context4.abrupt("return", (r.mode !== "hidden" && (r.mode = "hidden"), _toConsumableArray(t).sort(function (_ref16, _ref17) {
              var o = _ref16.time;
              var a = _ref17.time;
              return a - o;
            }).forEach(function (_ref18) {
              var o = _ref18.time,
                  a = _ref18.value;
              var u, l;
              var s = Array.prototype.findIndex.call(r == null ? void 0 : r.cues, function (T) {
                return T.startTime >= o;
              }),
                  i = (u = r == null ? void 0 : r.cues) == null ? void 0 : u[s],
                  d = i ? i.startTime : Number.isFinite(e.duration) ? e.duration : Number.MAX_SAFE_INTEGER,
                  c = (l = r == null ? void 0 : r.cues) == null ? void 0 : l[s - 1];
              c && (c.endTime = o);
              var p = new VTTCue(o, d, JSON.stringify(a != null ? a : null));
              r.addCue(p);
            }), r));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _$.apply(this, arguments);
}

var z = function z(e) {
  return {
    time: e.startTime,
    value: JSON.parse(e.text)
  };
};

function Te(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    label: P
  };
  var n = S(e, t);
  return n != null && n.cues ? Array.from(n.cues, function (r) {
    return z(r);
  }) : [];
}

function X(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    label: P
  };
  var a, s;
  var n = S(e, t);
  if (!((a = n == null ? void 0 : n.activeCues) != null && a.length)) return;
  var r = e.currentTime,
      o = Array.prototype.find.call((s = n.activeCues) != null ? s : [], function (_ref8) {
    var i = _ref8.startTime,
        d = _ref8.endTime;
    return i <= r && d > r;
  });
  return z(o);
}

function G(_x3) {
  return _G.apply(this, arguments);
}

function _G() {
  _G = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
    var t,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            t = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : _;
            return _context6.abrupt("return", new Promise(function (n) {
              M(e, "loadstart", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var r;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return $(e, [], t);

                      case 2:
                        r = _context5.sent;
                        M(e, "cuechange", function () {
                          var o = X(e);

                          if (o) {
                            var a = new CustomEvent("cuepointchange", {
                              composed: !0,
                              bubbles: !0,
                              detail: o
                            });
                            e.dispatchEvent(a);
                          }
                        }, {}, r), n(r);

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })));
            }));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _G.apply(this, arguments);
}

function ye(e, t) {
  if (t) {
    var n = t.playingDate;
    if (n != null) return new Date(n.getTime() - e.currentTime * 1e3);
  }

  return typeof e.getStartDate == "function" ? e.getStartDate() : new Date(NaN);
}

function me(e, t) {
  if (t && t.playingDate) return t.playingDate;

  if (typeof e.getStartDate == "function") {
    var n = e.getStartDate();
    return new Date(n.getTime() + e.currentTime * 1e3);
  }

  return new Date(NaN);
}

var ge = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetch(e).then(function (t) {
              return t.text();
            }).then(function (t) {
              var n = t.split("\n").find(function (r, o, a) {
                return o && a[o - 1].startsWith("#EXT-X-STREAM-INF");
              });
              return fetch(n).then(function (r) {
                return r.text();
              }).then(function (r) {
                return r.split("\n");
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function ge(_x4) {
    return _ref9.apply(this, arguments);
  };
}(),
    Me = function Me(e) {
  var s, i, d;
  var n = (i = ((s = e.find(function (c) {
    return c.startsWith("#EXT-X-PLAYLIST-TYPE");
  })) != null ? s : "").split(":")[1]) == null ? void 0 : i.trim(),
      r = I(n),
      o = D(n),
      a;

  if (r === v.LIVE) {
    var c = e.find(function (u) {
      return u.startsWith("#EXT-X-PART-INF");
    });
    if (!!c) a = +c.split(":")[1].split("=")[1] * 2;else {
      var u = e.find(function (y) {
        return y.startsWith("#EXT-X-TARGETDURATION");
      }),
          l = (d = u == null ? void 0 : u.split(":")) == null ? void 0 : d[1];
      a = +(l != null ? l : 6) * 3;
    }
  }

  return {
    streamType: r,
    targetLiveWindow: o,
    liveEdgeStartOffset: a
  };
},
    ve = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
    var n;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(t === b.MP4)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {
              streamType: v.ON_DEMAND,
              targetLiveWindow: Number.NaN,
              liveEdgeStartOffset: void 0
            });

          case 2:
            if (!(t === b.M3U8)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 5;
            return ge(e);

          case 5:
            n = _context2.sent;
            return _context2.abrupt("return", Me(n));

          case 7:
            return _context2.abrupt("return", (console.error("Media type ".concat(t, " is an unrecognized or unsupported type for src ").concat(e, ".")), {
              streamType: void 0,
              targetLiveWindow: void 0,
              liveEdgeStartOffset: void 0
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function ve(_x5, _x6) {
    return _ref10.apply(this, arguments);
  };
}(),
    J = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
    var n,
        s,
        i,
        d,
        _yield$ve,
        r,
        o,
        a,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            n = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : L({
              src: e
            });
            _context3.next = 3;
            return ve(e, n);

          case 3:
            _yield$ve = _context3.sent;
            r = _yield$ve.streamType;
            o = _yield$ve.targetLiveWindow;
            a = _yield$ve.liveEdgeStartOffset;
            ((s = m.get(t)) != null ? s : {}).liveEdgeStartOffset = a, ((i = m.get(t)) != null ? i : {}).targetLiveWindow = o, t.dispatchEvent(new CustomEvent("targetlivewindowchange", {
              composed: !0,
              bubbles: !0
            })), ((d = m.get(t)) != null ? d : {}).streamType = r, t.dispatchEvent(new CustomEvent("streamtypechange", {
              composed: !0,
              bubbles: !0
            }));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function J(_x7, _x8) {
    return _ref11.apply(this, arguments);
  };
}(),
    be = function be(e) {
  var s;
  var t = e.type,
      n = I(t),
      r = D(t),
      o,
      a = !!((s = e.partList) != null && s.length);
  return n === v.LIVE && (o = a ? e.partTarget * 2 : e.targetduration * 3), {
    streamType: n,
    targetLiveWindow: r,
    liveEdgeStartOffset: o,
    lowLatency: a
  };
},
    xe = function xe(e, t, n) {
  var i, d, c, p, u, l, T, y;

  var _be = be(e),
      r = _be.streamType,
      o = _be.targetLiveWindow,
      a = _be.liveEdgeStartOffset,
      s = _be.lowLatency;

  if (r === v.LIVE) {
    s ? (n.config.backBufferLength = (i = n.userConfig.backBufferLength) != null ? i : 4, n.config.maxFragLookUpTolerance = (d = n.userConfig.maxFragLookUpTolerance) != null ? d : .001, n.config.abrBandWidthUpFactor = (c = n.userConfig.abrBandWidthUpFactor) != null ? c : n.config.abrBandWidthFactor) : n.config.backBufferLength = (p = n.userConfig.backBufferLength) != null ? p : 8;
    var ce = Object.freeze({
      get length() {
        return t.seekable.length;
      },

      start: function start(k) {
        return t.seekable.start(k);
      },
      end: function end(k) {
        var V;
        return k > this.length ? t.seekable.end(k) : (V = n.liveSyncPosition) != null ? V : t.seekable.end(k);
      }
    });
    ((u = m.get(t)) != null ? u : {}).seekable = ce;
  }

  ((l = m.get(t)) != null ? l : {}).liveEdgeStartOffset = a, ((T = m.get(t)) != null ? T : {}).targetLiveWindow = o, t.dispatchEvent(new CustomEvent("targetlivewindowchange", {
    composed: !0,
    bubbles: !0
  })), ((y = m.get(t)) != null ? y : {}).streamType = r, t.dispatchEvent(new CustomEvent("streamtypechange", {
    composed: !0,
    bubbles: !0
  }));
},
    Q,
    j,
    ke = (j = (Q = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : Q.userAgent) != null ? j : "",
    Le = ke.toLowerCase().indexOf("android") !== -1,
    m = new WeakMap(),
    te = "mux.com",
    Z,
    ee,
    ne = (ee = (Z = f).isSupported) == null ? void 0 : ee.call(Z),
    Pe = Le,
    Pt = function Pt() {
  return O.utils.now();
},
    Ee = O.utils.generateUUID,
    Et = function Et() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref12.playbackId,
      _ref12$customDomain = _ref12.customDomain,
      t = _ref12$customDomain === void 0 ? te : _ref12$customDomain,
      n = _ref12.maxResolution,
      r = _ref12.minResolution,
      o = _ref12.renditionOrder,
      _ref12$tokens = _ref12.tokens;

  _ref12$tokens = _ref12$tokens === void 0 ? {} : _ref12$tokens;
  var a = _ref12$tokens.playback,
      _ref12$extraPlaylistP = _ref12.extraPlaylistParams,
      s = _ref12$extraPlaylistP === void 0 ? {} : _ref12$extraPlaylistP;
  if (!e) return;

  var _F = F(e),
      _F2 = _slicedToArray(_F, 2),
      i = _F2[0],
      _F2$ = _F2[1],
      d = _F2$ === void 0 ? "" : _F2$,
      c = new URL("https://stream.".concat(t, "/").concat(i, ".m3u8").concat(d));

  return a || c.searchParams.has("token") ? (c.searchParams.forEach(function (p, u) {
    u != "token" && c.searchParams.delete(u);
  }), a && c.searchParams.set("token", a)) : (n && c.searchParams.set("max_resolution", n), r && (c.searchParams.set("min_resolution", r), n && +n.slice(0, -1) < +r.slice(0, -1) && console.error("minResolution must be <= maxResolution", "minResolution", r, "maxResolution", n)), o && c.searchParams.set("rendition_order", o), Object.entries(s).forEach(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        p = _ref14[0],
        u = _ref14[1];

    u != null && c.searchParams.set(p, u);
  })), c.toString();
},
    Ae = function Ae(e) {
  if (!e) return;

  var _e$split = e.split("?"),
      _e$split2 = _slicedToArray(_e$split, 1),
      t = _e$split2[0];

  return t || void 0;
},
    he = function he(e) {
  if (!e || !e.startsWith("https://stream.")) return;

  var _URL$pathname$slice$s = new URL(e).pathname.slice(1).split(".m3u8"),
      _URL$pathname$slice$s2 = _slicedToArray(_URL$pathname$slice$s, 1),
      t = _URL$pathname$slice$s2[0];

  return t || void 0;
},
    Se = function Se(e) {
  var t, n, r;
  return (t = e == null ? void 0 : e.metadata) != null && t.video_id ? e.metadata.video_id : ae(e) && (r = (n = Ae(e.playbackId)) != null ? n : he(e.src)) != null ? r : e.src;
},
    At = function At(e) {
  var t;
  return (t = m.get(e)) == null ? void 0 : t.error;
},
    ht = function ht(e) {
  var t, n;
  return (n = (t = m.get(e)) == null ? void 0 : t.streamType) != null ? n : v.UNKNOWN;
},
    St = function St(e) {
  var t, n;
  return (n = (t = m.get(e)) == null ? void 0 : t.targetLiveWindow) != null ? n : Number.NaN;
},
    Ce = function Ce(e) {
  var t, n;
  return (n = (t = m.get(e)) == null ? void 0 : t.seekable) != null ? n : e.seekable;
},
    Ct = function Ct(e) {
  var r;
  var t = (r = m.get(e)) == null ? void 0 : r.liveEdgeStartOffset;
  if (typeof t != "number") return Number.NaN;
  var n = Ce(e);
  return n.length ? n.end(n.length - 1) - t : Number.NaN;
},
    Re = function Re(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .001;
  return Math.abs(e - t) <= n;
},
    re = function re(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .001;
  return e > t || Re(e, t, n);
},
    Ie = function Ie(e) {
  return e.paused && re(e.currentTime, e.duration);
},
    De = function De(e, t) {
  return e.loop || !!t ? e.ended : e.ended || Ie(e);
},
    Rt = function Rt(e, t, n) {
  we(t, n);
  var _e$metadata = e.metadata,
      r = _e$metadata === void 0 ? {} : _e$metadata,
      _r$view_session_id = r.view_session_id,
      o = _r$view_session_id === void 0 ? Ee() : _r$view_session_id,
      a = Se(e);
  r.view_session_id = o, r.video_id = a, e.metadata = r, m.set(t, {});
  var s = He(e, t);
  Ne(e, t, s), Oe(e, t, s), G(t);
  var i = B(e, t, s),
      d = K(e, t, s);
  return {
    engine: s,
    setAutoplay: i,
    setPreload: d
  };
},
    we = function we(e, t) {
  var n = t == null ? void 0 : t.engine;
  n && (n.detachMedia(), n.destroy()), (e == null ? void 0 : e.mux) && !e.mux.deleted && (e.mux.destroy(), delete e.mux), e && (e.removeAttribute("src"), e.load(), e.removeEventListener("error", se), e.removeEventListener("error", N), e.removeEventListener("durationchange", ie), m.delete(e), e.dispatchEvent(new Event("teardown")));
};

function oe(e, t) {
  var c;
  var n = L(e);
  if (!(n === b.M3U8)) return !0;
  var o = !n || ((c = t.canPlayType(n)) != null ? c : !0),
      a = e.preferPlayback,
      s = a === R.MSE,
      i = a === R.NATIVE;
  return o && (i || !(ne && (s || Pe)));
}

var He = function He(e, t) {
  var n = e.debug,
      r = e.streamType,
      _e$startTime = e.startTime,
      o = _e$startTime === void 0 ? -1 : _e$startTime,
      a = e.metadata,
      s = e.preferCmcd,
      d = L(e) === b.M3U8,
      c = oe(e, t);

  if (d && !c && ne) {
    var p = {
      backBufferLength: 30,
      renderTextTracksNatively: !1,
      liveDurationInfinity: !0,
      capLevelToPlayerSize: !0,
      capLevelOnFPSDrop: !0
    },
        u = _e(r),
        l = s !== A.NONE ? {
      useHeaders: s === A.HEADER,
      sessionId: a == null ? void 0 : a.view_session_id,
      contentId: a == null ? void 0 : a.video_id
    } : void 0;

    return new f(_objectSpread(_objectSpread({
      debug: n,
      startPosition: o,
      cmcd: l
    }, p), u));
  }
},
    _e = function _e(e) {
  return e === v.LIVE ? {
    backBufferLength: 8
  } : {};
},
    ae = function ae(_ref15) {
  var e = _ref15.playbackId,
      t = _ref15.src,
      n = _ref15.customDomain;
  if (e) return !0;
  if (typeof t != "string") return !1;
  var r = window == null ? void 0 : window.location.href,
      o = new URL(t, r).hostname.toLocaleLowerCase();
  return o.includes(te) || !!n && o.includes(n.toLocaleLowerCase());
},
    Ne = function Ne(e, t, n) {
  var a;
  var r = e.envKey,
      o = ae(e);

  if (r || o) {
    var s = e.playerInitTime,
        i = e.playerSoftwareName,
        d = e.playerSoftwareVersion,
        c = e.beaconCollectionDomain,
        p = e.debug,
        u = e.disableCookies,
        l = _objectSpread(_objectSpread({}, e.metadata), {}, {
      video_title: ((a = e == null ? void 0 : e.metadata) == null ? void 0 : a.video_title) || void 0
    }),
        T = function T(y) {
      return typeof y.player_error_code == "string" ? !1 : typeof e.errorTranslator == "function" ? e.errorTranslator(y) : y;
    };

    O.monitor(t, {
      debug: p,
      beaconCollectionDomain: c,
      hlsjs: n,
      Hls: n ? f : void 0,
      automaticErrorTracking: !1,
      errorTranslator: T,
      disableCookies: u,
      data: _objectSpread(_objectSpread({}, r ? {
        env_key: r
      } : {}), {}, {
        player_software_name: i,
        player_software: i,
        player_software_version: d,
        player_init_time: s
      }, l)
    });
  }
},
    Oe = function Oe(e, t, n) {
  var a;
  var r = oe(e, t),
      o = e.src;

  if (t && r) {
    var s = L(e);
    typeof o == "string" ? (t.preload === "none" ? M(t, "loadstart", function () {
      return J(o, t, s);
    }) : J(o, t, s), t.setAttribute("src", o), e.startTime && (((a = m.get(t)) != null ? a : {}).startTime = e.startTime, t.addEventListener("durationchange", ie, {
      once: !0
    }))) : t.removeAttribute("src"), t.addEventListener("error", se), t.addEventListener("error", N), t.addEventListener("emptied", function () {
      t.querySelectorAll("track[data-removeondestroy]").forEach(function (c) {
        c.remove();
      });
    }, {
      once: !0
    });

    var i = function i() {
      t.ended || !De(t) || t.dispatchEvent(new Event("ended"));
    };

    M(t, "pause", i), M(t, "seeked", i), M(t, "play", function () {
      t.ended || !re(t.currentTime, t.duration) || (t.currentTime = t.seekable.start(0));
    });
  } else n && o ? (n.once(f.Events.LEVEL_LOADED, function (s, i) {
    xe(i.details, t, n);
  }), n.on(f.Events.ERROR, function (s, i) {
    var _d;

    var d = (_d = {}, _defineProperty(_d, f.ErrorTypes.NETWORK_ERROR, g.MEDIA_ERR_NETWORK), _defineProperty(_d, f.ErrorTypes.MEDIA_ERROR, g.MEDIA_ERR_DECODE), _d),
        c = new g("", d[i.type]);
    c.fatal = i.fatal, c.data = i, t.dispatchEvent(new CustomEvent("error", {
      detail: c
    }));
  }), t.addEventListener("error", N), q(e, n), Y(t, n), n.attachMedia(t)) : console.error("It looks like the video you're trying to play will not work on this system! If possible, try upgrading to the newest versions of your browser or software.");
};

function ie(e) {
  var r;
  var t = e.target,
      n = (r = m.get(t)) == null ? void 0 : r.startTime;

  if (!!n && U(t.seekable, t.duration, n)) {
    var o = t.preload === "auto";
    o && (t.preload = "none"), t.currentTime = n, o && (t.preload = "auto");
  }
}

function se(_x9) {
  return _se.apply(this, arguments);
}

function _se() {
  _se = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
    var t, _t$error, n, r, o, _yield$fetch, a;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (e.isTrusted) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            e.stopImmediatePropagation();
            t = e.target;

            if (t != null && t.error) {
              _context7.next = 6;
              break;
            }

            return _context7.abrupt("return");

          case 6:
            _t$error = t.error, n = _t$error.message, r = _t$error.code, o = new g(n, r);

            if (!(t.src && (r !== g.MEDIA_ERR_DECODE || r !== void 0))) {
              _context7.next = 18;
              break;
            }

            _context7.prev = 8;
            _context7.next = 11;
            return fetch(t.src);

          case 11:
            _yield$fetch = _context7.sent;
            a = _yield$fetch.status;
            o.data = {
              response: {
                code: a
              }
            };
            _context7.next = 18;
            break;

          case 16:
            _context7.prev = 16;
            _context7.t0 = _context7["catch"](8);

          case 18:
            t.dispatchEvent(new CustomEvent("error", {
              detail: o
            }));

          case 19:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[8, 16]]);
  }));
  return _se.apply(this, arguments);
}

function N(e) {
  var r, o;
  if (!(e instanceof CustomEvent) || !(e.detail instanceof g)) return;
  var t = e.target,
      n = e.detail;
  !n || !n.fatal || (((r = m.get(t)) != null ? r : {}).error = n, (o = t.mux) == null || o.emit("error", {
    player_error_code: n.code,
    player_error_message: n.message,
    player_error_context: n.context
  }));
}

export { E as AutoplayTypes, We as CmcdTypeValues, A as CmcdTypes, b as ExtensionMimeTypeMap, f as Hls, qe as MaxResolution, g as MediaError, h as MimeTypeShorthandMap, Ye as MinResolution, R as PlaybackTypes, $e as RenditionOrder, v as StreamTypes, $ as addCuePoints, H as addTextTrack, Ke as allMediaTypes, Pt as generatePlayerInitTime, Ee as generateUUID, X as getActiveCuePoint, Te as getCuePoints, S as getCuePointsTrack, me as getCurrentPdt, De as getEnded, At as getError, Ct as getLiveEdgeStart, ge as getMediaPlaylistLinesFromMultivariantPlaylistSrc, Ce as getSeekable, ye as getStartDate, be as getStreamInfoFromHlsjsLevelDetails, Me as getStreamInfoFromPlaylistLines, ve as getStreamInfoFromSrcAndType, ht as getStreamType, _e as getStreamTypeConfig, St as getTargetLiveWindow, Rt as initialize, C as isKeyOf, ae as isMuxVideoSrc, Ie as isPseudoEnded, Oe as loadMedia, O as mux, m as muxMediaState, fe as removeTextTrack, G as setupCuePoints, He as setupHls, Ne as setupMux, Be as shorthandKeys, we as teardown, Et as toMuxVideoURL, xe as updateStreamInfoFromHlsjsLevelDetails, J as updateStreamInfoFromSrc };